const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b6aa69c2ae2f9c2aedcadf6d40ab0346af5a2052"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-frontend@codingal-inc"]={id:"b6aa69c2ae2f9c2aedcadf6d40ab0346af5a2052"};
      